import { React, useState, useEffect } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
  RightDrawerContainer,
  DownArrowDraw,
  DropDownSearchDraw
} from "../../styledElements";
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Select,
  PageHeader,
  textarea,
} from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import moment from "moment";
import { DatePickerY, GlobalSet } from "../../pageStyled";
import { addJumboReel } from "../../../Services/productionPlanningServices";
import {
  getProductDetails,
  getProductsData,
  getProducts
} from "../../../Services/productServices";
import { paperMachineListData } from "../../../Services/machineServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { getUnitData } from "../../../Services/measurementService";
import { lengthUnit, weightUnit, conversionFactorUnitsToTonne, conversionFactorTonneToUnits, CoversionFactorCMToUnits, CoversionFactorUnitsToCM } from "../../../Utils/Constant/MeasurementUnitList";
import { getJumboReels } from "../../../Services/productionPlanningServices";

const { RangePicker } = DatePicker;
const dateFormat = "YYYY/MM/DD";
const customFormat = (value) => `custom format: ${value.format(dateFormat)}`;
const { Option } = Select;
const shiftData = ["1st", "2nd", "3rd"];
const { TextArea } = Input;

const AddNewJumboReel = (props) => {
  const [products, setProducts] = useState([]);
  const [productData, setProductData] = useState({
    bulk: "",
    gsm: "",
  });
  const [machines, setMachines] = useState([]);
  const [machine, setMachine] = useState();
  const [shift, setshift] = useState(shiftData[0]);
  const [date, setDate] = useState();
  const [form] = Form.useForm();
  const [showToaster, setShowToaster] = useState(false);
  const [number, setNumber] = useState();
  const [actionToaster, setActionToaster] = useState({
    error: "",
    msg: "",
  });
  const location = useLocation();
  // const existingIds = location.state.existingIds;
  const [existingIds, setExistingIds] = useState([]);
  const navigate = useNavigate();
  const [isProductDropdownOpen, setProductDropdown] = useState(false);
  const [measurementData, setMeasurementData] = useState();
  const [weightErr, setWeightErr] = useState(false);
  const [widthErr, setWidthErr] = useState(false);


  const OnProductToggleSelect =()=>{
    setProductDropdown((prevState) => !prevState
  )
  }
  useEffect(() => {
    // getProductsData()
    //   .then((response) => {
    //     setProducts(response);
    //   })
    //   .catch((error) => {
    //     console.log("Error in fetching products list:", error);
    //   });
    getProducts({ status: "active" })
    .then((response) => {
      setProducts(response);
    })
    .catch((error) => {
      console.log("Error in fetching products list:", error);
    });
  }, []);

  useEffect(() => {
    paperMachineListData()
      .then((response) => {
        const codes = response.map((machine) => {
          return machine.code;
        });
        setMachines(codes);
      })
      .catch((error) => {
        console.log("Error in fetching products list:", error);
      });
  }, []);

  useEffect(() => {
    getUnitData()
      .then((response) => {
        if(response && !response.error){
          setMeasurementData(response.data);
          form.setFieldsValue({weightUnit: response.data.units_management.weight.default});
          form.setFieldsValue({unit: location.state.parentPage !== "productionDetails" ? response.data.units_management.length.default : lengthUnit[location.state.widthUnit]?.displayName});
        }
      })
      .catch((error) => {
        console.log("Error in fetching advanced settings data:", error);
      });
  }, []);

  useEffect(() => {
    getJumboReels()
      .then((resp) => {
        if(resp && !resp.data.error){
          let jumboRollArr = [];
          resp.data.data.map((item) => {
            jumboRollArr.push(item.number);
          });
          setExistingIds(jumboRollArr);
        }
      })
      .catch((error) => {
        console.log("Jumbo reels fetch error", error);
      });
  }, []);

  const handleShiftChange = (value) => {
    setshift(shiftData[value]);
  };
  const handleProduct = (e) => {
    getProductDetails(e)
      .then((response) => {
        setProductData({
          bulk: `${response.data.bulk}`,
          gsm: `${response.data.gsm}`,
        });
        form.setFieldsValue({ product_spec: response.data.product_spec });
      })
      .catch((error) => {
        console.log("Error in getting product specification list");
      });
  };
  const handleMachineChange = (value) => {
    setMachine(value);
  };

  const dateHandler = (e) => {
    const testDate = new Date(e._d);
    setDate(moment(testDate).format("YYYY-MM-DD"));
  };
  const onWeightChange = (e) => {
    if(location.state && location.state?.parentPage == "productionDetails"){
      let weightUnit = form.getFieldValue("weightUnit");
      let parentWeight = location.state.parentWeight;
      let parentUnit = location.state.parentWeightUnit;
      if(e.target.value && e.target.value != "" && weightUnit){
        let convertedWeightToTonne = e.target.value * conversionFactorUnitsToTonne[weightUnit];
        let convertedWeightTonneToUnit = convertedWeightToTonne * conversionFactorTonneToUnits[parentUnit];
        if(parentWeight > convertedWeightTonneToUnit){
          setWeightErr(true);
        } else{
          setWeightErr(false);
        }
      } else{
        setWeightErr(false);
      }
    }
  };
  const handleUnitChange = (e) => {
    if(location.state && location.state?.parentPage == "productionDetails"){
      let weightValue = form.getFieldValue("weight");
      let parentWeight = location.state.parentWeight;
      let parentUnit = location.state.parentWeightUnit;
      if(e && e != "" && weightValue){
        let convertedWeightToTonne = weightValue * conversionFactorUnitsToTonne[e];
        let convertedWeightTonneToUnit = convertedWeightToTonne * conversionFactorTonneToUnits[parentUnit];
        if(parentWeight > convertedWeightTonneToUnit){
          setWeightErr(true);
        } else{
          setWeightErr(false);
        }
      }
    }
  };
  const onWidthChange = (e) => {
    let parentWidth = location.state.widthKey;
    let parentUnit = location.state.widthUnit;
    let childUnit = form.getFieldValue("unit");
    let childWidth = e.target.value;
    if(location.state.actionFrom === "mapping drawer" && e.target.value != ""){
      let parentWidthInCM = parentWidth * CoversionFactorUnitsToCM[parentUnit];
      let childWidthInCM = childWidth * CoversionFactorUnitsToCM[childUnit];
      if(parentWidthInCM != Math.round(childWidthInCM?.toFixed(3))){
        setWidthErr(true);
      } else{
        setWidthErr(false);
      }
    }
  };

  const handleWidthUnit = (e) => {
    let parentWidth = location.state.widthKey;
    let parentUnit = location.state.widthUnit;
    let childUnit = e;
    let childWidth = form.getFieldValue("width");
    if(location.state.actionFrom === "mapping drawer" && e != ""){
      let parentWidthInCM = parentWidth * CoversionFactorUnitsToCM[parentUnit];
      let childWidthInCM = childWidth * CoversionFactorUnitsToCM[childUnit];
      if(parentWidthInCM != Math.round(childWidthInCM?.toFixed(3))){
        setWidthErr(true);
      } else{
        setWidthErr(false);
      }
    }
  };

  const onFinish = async (values) => {
    if ((existingIds.filter((data) => data.toUpperCase() === values.number.toUpperCase()).length) || weightErr || widthErr) {
      if(existingIds.filter((data) => data.toUpperCase() === values.number.toUpperCase()).length){
        setActionToaster({
          error: true,
          msg: `This jumbo roll already exists in the system. Enter a unique value`,
        });
        setShowToaster(true);
      }
    } else {
      const body = {
        number: values.number.toUpperCase(),
        product: values.product,
        production_date: date,
        shift: shift,
        weight: values.weight,
        machine: machine? machine : values.machine,
        width: values.width,
        remarks: values.remarks,
        weight_utilized: 0,
        units:{
          weight: values.weightUnit,
          weight_utilized: values.weightUnit,
          width: values.unit
        }
      };
      addJumboReel(body)
        .then((resp) => {
          setNumber(values.number);
          setActionToaster({
            error: resp.error,
            msg: `Jumbo Reel ${values.number.toUpperCase()} is successfully added`,
          });
          setShowToaster(true);
          if(location.state.actionFrom !== "mapping drawer") {
            setTimeout(() => {
              navigate("../jumbo-reel-records");
            }, 1500);
          } else{
            setTimeout(() => {
              navigate(location.state.rootPage, {
                state: {
                  openDrawer: true,
                  id: location.state.id,
                  parentReelId: location.state.parentReelId,
                  data:resp.data.data,
                  type: location.state.type,
                  machineCode: location.state.machineCode,
                  productCode: location.state.productCode,
                  productSpec: location.state.productSpec,
                  widthKey: location.state.widthKey,
                  widthUnit: location.state.widthUnit,                  
                  parentWeight: location.state.parentWeight,
                  parentWeightUnit: location.state.parentWeightUnit,
                  selectedDate: location.state.selectedDate,
                  selectedShift: location.state.selectedShift,
                  machineType: location.state.machineType
                },
              })
            }, 1500);
          }
        })
        .catch((err) => {
          //console.log(err.data);
          // setActionToaster({
          //   error: true,
          //   msg: `Error while adding Jumbo reel`,
          // });
          // setShowToaster(true);
          if(err?.response?.status == 500){
              setActionToaster({
                error: true,
                msg: "Something went wrong. Please try again",
              });
            } else{
              setActionToaster({
                error: true,
                msg: err?.response?.data?.msg,
              });
            }
            setShowToaster(true);
        });
    }
  };

  return (products && machines && measurementData) ? (
    <RightLayoutContainer>
      <PageTitleComp className="marginRightAdg">
        <PageHeader
          ghost={false}
          //onBack={() => window.history.back()}
          title="Add a New Jumbo Reel"
          extra={[
            <Button
              key="3"
              className="textTypeBtn"
              onClick={() => location.state.parentPage !== "productionDetails" ? window.history.back() : 
              navigate(location.state.rootPage , {
                state: {
                  openDrawer: true,
                  id: location.state.id,
                  parentReelId: location.state.parentReelId,
                  type: location.state.type,
                  machineCode: location.state.machineCode,
                  productCode: location.state.productCode,
                  productSpec: location.state.productSpec,
                  widthKey: location.state.widthKey,
                  widthUnit: location.state.widthUnit,
                  parentWeight: location.state.parentWeight,
                  parentWeightUnit: location.state.parentWeightUnit,
                  selectedDate: location.state.selectedDate,
                  selectedShift: location.state.selectedShift,
                  jobcardType: location.state.jobcardType,
                  machineType: location.state.machineType
                },
              })}
            >
              Cancel changes
            </Button>,
            <Button key="2" className="themeBtn" onClick={() => form.submit()}>
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              Add Jumbo
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <DetailFields>
        <HaberForm>
          <div className="groupDetailWrap">
            <Form
              name="basic"
              autoComplete="off"
              className="haberLogin"
              form={form}
              onFinish={onFinish}
            >
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>General Details</h2>
                    <p>
                      The general details of the jumbo reel will be used in
                      reports and production details
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Jumbo Roll Number</label>
                        <p>Jumbo reel will be identified by this number</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="number"
                          rules={[
                            {
                              required: true,
                              message: "This is a mandatory field",
                            },
                            {
                              max: 50,
                              message: "Max 50 characters are allowed",
                            },
                            {
                              validator(_, value) {
                                if (existingIds) {
                                if (
                                  value == null ||
                                  !existingIds.filter((data) => data.toUpperCase() === value.toUpperCase()).length
                                ) {
                                  return Promise.resolve();
                                } else {
                                  return Promise.reject(
                                    "This jumbo roll already exists in the system. Enter a unique value"
                                  );
                                }
                              }
                            },
                          }
                          ]}
                          className=""
                        >
                          <Input
                            placeholder="Enter Jumbo Roll Number"
                            initialValue=""
                            style={{ textTransform: "uppercase" }}
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Product Specifications</h2>
                    <p>
                      The product specification will be used to define grade and
                      quality of the jumbo reel
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Name</label>
                        <p>Unique name to identify the product</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="product"
                          rules={[
                            {
                              required: true,
                              message: "This field is mandatory",
                            },
                          ]}
                          className=""
                          initialValue={location.state.actionFrom === "mapping drawer" ? location.state.productCode : ""}
                        >
                          <Select
                            placeholder="Select product name"
                            suffixIcon={ isProductDropdownOpen ? <DropDownSearchDraw/>:<DownArrowDraw />}
                            onBlur = {OnProductToggleSelect}
                            onFocus = {OnProductToggleSelect}
                            showSearch
                            optionFilterProp="children"
                            defaultValue={products[0]}
                            onChange={handleProduct}
                          >
                            {products.map((product) => (
                              <Option key={product.code}>
                                {product.code} - {product.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Product Specifications</label>
                        <p>Combination of Grade/GSM/BF/Quality/Moisture</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="product_spec"
                          rules={[{}]}
                          className=""
                          initialValue={location.state.actionFrom === "mapping drawer" ? location.state.productSpec : ""}
                        >
                          <Input
                            placeholder="Product Specifications"
                            defaultValue=""
                            disabled
                          />
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Production Details</h2>
                    <p>
                      The production details specify when and where will this
                      jumbo roll be produced.
                    </p>
                  </GroupTitle>
                </Col>
                <Col span={16} className="blockBreak">
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Production Date</label>
                        <p>The production date of this jumbo reel</p>
                      </div>
                    </Col>

                    <Col span={12} className="blockBreak">
                      <div className="boxFormType">
                        <DatePickerY>
                          <Form.Item
                            name="production_date"
                            rules={[
                              {
                                required: true,
                                message: "This field is mandatory",
                              },
                            ]}
                          >
                            <DatePicker
                              format={"YYYY-MM-DD"}
                              onChange={dateHandler}
                            />
                          </Form.Item>
                        </DatePickerY>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Shift</label>
                        <p>Production shift for this jumbo reel </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          rules={[
                            {
                              required: true,
                              message: "This field is mandatory",
                            },
                          ]}
                        >
                          <Select
                            placeholder="Select shift"
                            suffixIcon={<DownArrowDraw />}
                            defaultValue={shiftData[0]}
                            onChange={handleShiftChange}
                          >
                            {shiftData.map((shift) => (
                              <Option key={shift}>{shift}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>                  
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Weight</label>
                        <p>Weight of the jumbo reel</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign" style={{marginBottom: "-24px"}}>
                        <Col span={24} className="d-flex">
                          <div className="boxFormType">
                            <Form.Item
                              name="weight"
                              rules={[
                                {
                                  required: true,
                                  message: "Mandatory field.",
                                },
                                {
                                  pattern: new RegExp(/^\d+(\.\d+)?$/),
                                  message: "Only Numeric & Decimal Input allowed",
                                },
                                {
                                  max: 50,
                                  message: "Max 50 characters allowed",
                                },
                              ]}
                              className=""
                            >
                              <Input placeholder="Enter Weight" 
                                onChange={(e) => {
                                  onWeightChange(e);
                                }}
                              />
                            </Form.Item>
                          </div>
                          <div className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}>
                          <Form.Item
                            name="weightUnit"
                            rules={[
                              {
                                required: true,
                                message: "This is a required field",
                              },
                            ]}
                            className=""
                          >
                            <Select
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw/>}
                              onChange={(e) => {
                                handleUnitChange(e);
                              }}
                            >
                              {measurementData.units_management.weight.data.map((item) => (
                                <Option key={item} value={item}>
                                  {weightUnit[item]?.displayName}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          </div>
                        </Col>
                        <Col>
                        {weightErr ? (
                        <span
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginTop: "-17px",
                          }}
                        >
                        Jumbo roll weight cannot be less than the parent set {"( " + location?.state?.parentWeight?.toFixed(3) + " " + weightUnit[location?.state?.parentWeightUnit]?.displayName + " )"} for which you are creating the jumbo roll.
                        </span>
                       ) : null}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Machine</label>
                        <p>
                          The Jumbo reel with be produced on selected machine
                        </p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <Form.Item
                          name="machine"
                          rules={[
                            {
                              required: true,
                              message: "This field is mandatory",
                            },
                          ]}
                          initialValue={location.state.actionFrom === "mapping drawer" ? location.state.machineCode : ""}
                        >
                          <Select
                            placeholder="Select machine"
                            suffixIcon={<DownArrowDraw />}
                            defaultValue={machines[0]}
                            onChange={handleMachineChange}
                            showSearch 
                            optionFilterProp="children" 
                          >
                            {machines.map((machine) => (
                              <Option key={machine}>{machine}</Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>Width</label>
                        <p>Width of the jumbo reel</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <Row className="centerAlign" style={{marginBottom: "-24px"}}>
                        <Col span={24} className="d-flex">
                          <div className="boxFormType">
                            <Form.Item
                            name="width"
                            rules={[
                              {
                                required: true,
                                message: "Mandatory field.",
                              },
                              {
                                pattern: new RegExp(/^\d+(\.\d+)?$/),
                                message: "Only Numeric & Decimal Input allowed",
                              },
                              {
                                max: 50,
                                message: "Max 50 characters allowed",
                              },
                            ]}
                            className=""
                            initialValue={location.state.actionFrom === "mapping drawer" ? location.state.widthKey?.toString() : ""}
                          >
                            <Input 
                            placeholder="Enter Width" 
                            onChange={(e) => onWidthChange(e)}/>
                            </Form.Item>
                          </div>
                          <div className="boxFormType unitSelect"
                            style={{ marginBottom: "0" }}>
                            <Form.Item
                            name="unit"
                            rules={[
                              {
                                required: true,
                                message: "This is a required field",
                              },
                            ]}
                            className=""
                            initialValue={location.state.actionFrom === "mapping drawer" ? lengthUnit[location.state.widthUnit]?.displayName : ""}
                          >
                            <Select
                              placeholder="Unit"
                              suffixIcon={<DownArrowDraw />}
                              onChange={handleWidthUnit}
                            >
                              {measurementData.units_management.length.data.map((item) => (
                                <Option key={item} value={item}>
                                {lengthUnit[item]?.displayName}
                              </Option>
                              ))}
                            </Select>
                            </Form.Item>
                          </div>
                        </Col>
                        <Col>
                        {widthErr ? (
                        <span
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginTop: "-2px",
                          }}
                        >
                        Jumbo roll width should match with required deckle length {"( " + location?.state?.widthKey + " " + lengthUnit[location?.state?.widthUnit]?.displayName + " )"} for which you are creating the jumbo roll.
                        </span>
                       ) : null}
                        </Col>
                      </Row>  
                    </Col>
                    {/* <Col span={12} className="d-flex">
                      <div
                        className="boxFormType"
                        style={{ marginBottom: "0", width: "90%", paddingRight:'5px' }}
                      >
                        <Form.Item
                          name="width"
                          rules={[
                            {
                              required: true,
                              message: "Mandatory field.",
                            },
                            {
                              pattern: new RegExp(/^\d+(\.\d+)?$/),
                              message: "Only Numeric & Decimal Input allowed",
                            },
                            {
                              max: 50,
                              message: "Max 50 characters allowed",
                            },
                          ]}
                          className=""
                          initialValue={location.state.actionFrom === "mapping drawer" ? location.state.widthKey?.toString() : ""}
                        >
                          <Input 
                          placeholder="Enter Width" 
                          onChange={(e) => onWidthChange(e)}/>
                        </Form.Item>
                      </div>
                      <div
                        className="boxFormType"
                        style={{ marginTop: "7px", width: "90%" }}
                      >
                        <Form.Item
                          name="unit"
                          rules={[
                            {
                              required: true,
                              message: "This is a required field",
                            },
                          ]}
                          className=""
                          initialValue={location.state.actionFrom === "mapping drawer" ? lengthUnit[location.state.widthUnit]?.displayName : ""}
                        >
                          <Select
                            placeholder="Unit"
                            suffixIcon={<DownArrowDraw />}
                            onChange={handleWidthUnit}
                          >
                            {measurementData.units_management.length.data.map((item) => (
                              <Option key={item} value={item}>
                              {lengthUnit[item]?.displayName}
                            </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </div>
                    </Col>
                    <Col Col span={12}></Col>
                    <Col span={12}>
                    {widthErr ? (
                        <span
                          className="errorText"
                          style={{
                            color: "#ea4e2c",
                            marginTop: "-2px",
                          }}
                        >
                        Jumbo roll width should match with required deckle length {"( " + location?.state?.widthKey + " " + lengthUnit[location?.state?.widthUnit]?.displayName + " )"} for which you are creating the jumbo roll.
                        </span>
                      ) : null}</Col> */}

                  </Row>
                </Col>
              </Row>
              <Row gutter={[16, 16]} className="groupForm lastGroup">
                <Col span={8}>
                  <GroupTitle>
                    <h2>Other Information</h2>
                    <p>All other information related to this jumbo roll</p>
                  </GroupTitle>
                </Col>
                <Col span={16}>
                  <Row className="centerAlign">
                    <Col span={12}>
                      <div className="boxFieldTitle">
                        <label>
                          Remarks <span>(Optional)</span>
                        </label>
                        <p>Extra information related to this jumbo roll</p>
                      </div>
                    </Col>
                    <Col span={12}>
                      <div className="boxFormType">
                        <GlobalSet>
                          <Form.Item
                            name="remarks"
                            rules={[
                              {
                                max: 50,
                                message: "Max 50 characters are allowed",
                              },
                            ]}
                            className=""
                          >
                            <TextArea
                              maxLength={100}
                              style={{ height: 90 }}
                              placeholder="Enter remarks"
                              defaultValue=""
                            />
                          </Form.Item>
                        </GlobalSet>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </div>
        </HaberForm>
      </DetailFields>
      {showToaster && (
        <AlertContainer
          closeIcon={true}
          setClose={setShowToaster}
          color={actionToaster.error ? "red toaster" : "green toaster"}
          icon={actionToaster.error ? alertRed : alertGreen}
          msg={actionToaster.msg}
        >
          {setTimeout(() => setShowToaster(false), 3000)}
        </AlertContainer>
      )}
    </RightLayoutContainer>
  ) : null;
};

export default AddNewJumboReel;
